import React from 'react';
import styles from './index.module.scss';
import PublicationSliderV1 from '../../imgs_block_components/publication_slider_v1';

const ItemMainBlockV1 = ({ block, path_to_folder }) => {
  if (!block) {
    return null;
  }

  const sliderItems = Array.isArray(block.block_content)
    ? block.block_content.filter((contentItem) => (contentItem?.cotent_type === 'imgs_block' || contentItem?.content_type === 'imgs_block'))
    : [];

      return (
    <section className={styles.itemMainBlockV1}>
      {block.block_title && <h3 className={styles.title}>{block.block_title}</h3>}

      {sliderItems.length > 0 && (
        <div className={styles.content}>
          {sliderItems.map((contentItem, index) => (
        <PublicationSliderV1
          key={index}
          contentData={contentItem}
          contentText={contentItem.content_text}
          contentName={contentItem.cotent_name || contentItem.content_name}
          imgName={contentItem.img_name}
          imgsNames={contentItem.imgs_names}
          videoName={contentItem.video_name}
          path_to_folder={path_to_folder}
        />
          ))}
        </div>
      )}
    </section>
  );
};

export default ItemMainBlockV1;
